import { Smileys } from "iconsax-react";

const FEATURES = [
  {
    icon: <Smileys />,
    title: "Macro Balanced",
    desc: "We take portion control seriously with high protein, macro perfect dishes no matter which menu you choose! All food is weighed and portioned out to perfection so you can hit your daily protein goals with ease."
  },
  {
    icon: <Smileys />,
    title: "High Quality Ingredients",
    desc: "We procure food from single source quality vendors. Meat, Poultry, fish, eggs, vegetables and dairy products are obtained only after thorough checks. No artifial color,no sweetners or taste enhancer are used."
  },
  {
    icon: <Smileys />,
    title: "Delivered Fresh",
    desc: "These aren't the frozen TV dinners you find in the store. Every dish is prepared fresh and delivered fresh in a sealed container. No overnight gravy or food items are used. Eat clean and stay healthy."
  },
  {
    icon: <Smileys />,
    title: "Low Calories & High Protein Meals",
    desc: "We aren't in the business of bro science. Our protein-packed recipes are created by credentialed recipe experts and backed by experienced fitness professionals who tried our meals."
  },
  {
    icon: <Smileys />,
    title: "Reheat & Eat",
    desc: "No recipe cards or meal kit required! All our food is cooked, seasoned, and ready-to-eat by the time it arrives at your door. Only one step needed - just heat for few minutes in the oven, air fryer or on microwave!"
  },
  {
    icon: <Smileys />,
    title: "Rotational dishes every week",
    desc: "No boring repetitive meals. Add variety to your meal prep with mouthwatering new recipes every week. Our chefs plan a versatile healthy menu so you don't have to eat the same thing every day."
  },
]

export default FEATURES;